<template>
  <div class="show-card fade-in-fast">
    <router-link :to="{ name: 'Podcasts', params: { id: showData.permlink } }">
      <div class="show-card__image">
        <div class="show-card__image__tagline">
          <span>show</span>
        </div>
        <picture class="show-card__image__thumb-container">
          <img
            class="show-card__image__thumb-container__thumb"
            :src="$router.options.imagePath + showData.urlMedia"
          />
        </picture>
      </div>
      <div class="show-card__data">
        <div class="show-card__data__wrapper">
          <div class="show-card__data__header">
            <span>{{ showData.locationModel.locationname }}</span>
          </div>
          <div class="show-card__data__heading">
            <div class="show-card__data__heading__title">
              {{ showData.name }}
            </div>
            <div v-if="showData.artistName && !episodeNameHasSameArtistName" class="show-card__data__heading__subtitle">
              <span>w/</span>
              <span>{{ showData.artistName }}</span>
            </div>
            <div class="show-card__data__heading__frequency">
              {{ showData.frequency }}
            </div>
          </div>
          <div v-if="$slots['show-description']" class="show-card__data__heading__description">
            <slot name="show-description" />
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>
<script>
export default {
  name: 'ShowCard',
  props: {
    showData: { type: Object, required: true, default: () => {} }
  },
  computed: {
    episodeNameHasSameArtistName() {
      return String(this.showData.name).valueOf().trim() === String(this.showData.artistName).valueOf().trim();
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_show-card.scss';
</style>
